import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Paper,
  Box,
  Tooltip,
  Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useGlobalModalContext } from '../context/GlobalModalContext';

function SourceDialog({ metadata = [] }) {
  //console.log('metadata', metadata)
  const { hideModal } = useGlobalModalContext();
  const handleClose = () => {
    hideModal();
  };
  const handleCopyPath = (path) => {
    try {
      navigator.clipboard.writeText(path);
    } catch (error) {
      console.log('Failed to copy path:', error);
    }
  };

  const formatFileSize = (bytes) => {
    const mb = bytes / (1024 * 1024);
    return `${mb.toFixed(2)} MB`;
  };

  return (
    <Dialog
      open
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          maxHeight: '80vh',
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2, backgroundColor: '#f5f5f5' }}>
        <Typography variant="h6" component="div">
          Source Details
        </Typography>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 2 }}>
        <Box sx={{ maxHeight: '60vh', overflow: 'auto' }}>
          {metadata?.map((item, index) => (
            <Paper
              key={`${item.file_name}-${item.page_number}-${index}`}
              elevation={0}
              sx={{
                p: 2,
                mb: 2,
                border: '1px solid #e0e0e0',
                backgroundColor: '#fafafa',
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {/* File Name */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="subtitle2" color="primary" sx={{ minWidth: '100px' }}>
                    File Name:
                  </Typography>
                  <Typography variant="body2">{item.file_name}</Typography>
                </Box>

                {/* File Path */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="subtitle2" color="primary" sx={{ minWidth: '100px' }}>
                    File Path:
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      color: '#0066cc',
                      flex: 1,
                      wordBreak: 'break-all',
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      const path = item.file_path.replace(/\\/g, '/');
                      const url = `https://parahu.basic.box.cloudeka.id/dekaboxacn/AI_RM/${path}#page=${item.page_number}`;
                      window.open(url, '_blank');
                    }}
                  >
                    {item.file_path.replace(/\\/g, '/')}
                  </Typography>
                  {/* <Tooltip title="Copy path">
                    <IconButton 
                      size="small" 
                      onClick={() => handleCopyPath(item.file_path)}
                      sx={{ ml: 1 }}
                    >
                      <ContentCopyIcon fontSize="small" />
                    </IconButton>
                  </Tooltip> */}
                </Box>

                {/* File Details */}
                <Box sx={{ display: 'flex', gap: 4 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="subtitle2" color="primary">
                      Size:
                    </Typography>
                    <Typography variant="body2">
                      {formatFileSize(item.file_size)}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="subtitle2" color="primary">
                      Page:
                    </Typography>
                    <Typography variant="body2">
                      {item.page_number}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="subtitle2" color="primary">
                      Lines:
                    </Typography>
                    <Typography variant="body2">
                      {item.line_range}
                    </Typography>
                  </Box>
                </Box>

                {/* Modification Date */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="subtitle2" color="primary" sx={{ minWidth: '100px' }}>
                    Modified:
                  </Typography>
                  <Typography variant="body2">
                    {new Date(item.modification_date).toLocaleString()}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default SourceDialog;
